<template>
    <div class="mb-5">
        <h4>Request</h4>
        
        <div class="alert alert-danger mb-4" role="alert" v-if="fulfillment.status === 'denied'">
            <b>{{ fulfillment.status_note }}</b><br>
            Note: {{ fulfillment.fulfillment_notes }}
        </div>
        <div class="alert alert-success mb-4" role="alert" v-if="fulfillment.status === 'done'">
            <b>{{ fulfillment.status_note }}</b>
        </div>

        <div class="row mt-3">
            <div class="col-4">
                <div class="row report-row">
                    <div class="col-4">
                        Employer
                    </div>
                    <div class="col-6">
                        <a :href="url(`admin/employer/${fulfillment.employer_id}/budgets`)">{{ fulfillment.employer_name }}</a>
                    </div>
                </div>
                <div class="row report-row">
                    <div class="col-4">
                        Campaign
                    </div>
                    <div class="col-6">
                        <a :href="url(`admin/employer/${fulfillment.employer_id}/budgets`)">{{ fulfillment.campaign_name }}</a>
                    </div>
                </div>
                <div class="row report-row">
                    <div class="col-4">
                        Job
                    </div>
                    <div class="col-6" v-if="fulfillment.job_id">
                        {{ job.title }}<br>
                        <a :href="url(`admin/jobs/${fulfillment.job_id}`)">link</a>, <a :href="job.public_url" v-if="job.public_url">public link</a>
                    </div>
                </div>
                <div class="row report-row">
                    <div class="col-4">
                        Order type
                    </div>
                    <div class="col-6">
                        <el-select 
                            v-model="fulfillment.order_type" 
                            placeholder="Select an order type"
                            style="width: 100%"
                        >
                            <el-option
                                v-for="(option) in lists.order_types"
                                :key="option.id"
                                :label="option.name"
                                :value="option.id">
                            </el-option>
                        </el-select>

                        <div class="mt-2">
                            <btn :click="save" v-if="! readonly">Save</btn>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-4">
                <div class="row report-row">
                    <div class="col-4">
                        Pay
                    </div>
                    <div class="col-6">
                        {{ fulfillment.job_pay }}
                    </div>
                </div>
                <div class="row report-row">
                    <div class="col-4">
                        Hometime
                    </div>
                    <div class="col-6">
                        {{ fulfillment.job_hometime }}
                    </div>
                </div>
                <div class="row report-row">
                    <div class="col-4">
                        Equipment type
                    </div>
                    <div class="col-6">
                        {{ fulfillment.job_equipment }}
                    </div>
                </div>
            </div>
            <div class="col-4">
                <div class="row report-row">
                    <div class="col-4">
                        Request By
                    </div>
                    <div class="col-6">
                        {{ fulfillment.requested_by }}
                    </div>
                </div>
                <div class="row report-row">
                    <div class="col-4">
                        Request Date
                    </div>
                    <div class="col-6">
                        {{ fulfillment.requested_at }}
                    </div>
                </div>
                <div class="row report-row">
                    <div class="col-4">
                        Requested For
                    </div>
                    <div class="col-6">
                        {{ fulfillment.requested_for }}
                    </div>
                </div>
                <div class="row report-row">
                    <div class="col-4">
                        How
                    </div>
                    <div class="col-6">
                        {{ fulfillment.leads_pacing }}
                    </div>
                </div>
            </div>
        </div>

        <p class="mt-3">
            Notes<br>
            <i>{{ fulfillment.request_notes }}</i>
        </p>
    </div>
</template>

<script>
    export default {
        props: [
            'fulfillment',
            'job',
            'lists',
            'readonly',
        ],
        methods: {
            save() {
                return axios.post(url(`de/fulfillment/${this.fulfillment.id}/order`), {
                    order_type: this.fulfillment.order_type
                }).then((response) => {
                    this.$emit('changed');
                });
            },
        },
    }
</script>

<style scoped>
    div .report-row {
        margin-bottom: 10px;
    }
    div.alert b {
        font-size: 18px;
    }
</style>
